import axios from "axios";
const crypto = require("crypto");

export function generateChecksum(str, algorithm, encoding) {
  return crypto
    .createHash(algorithm || "md5")
    .update(str, "utf8")
    .digest(encoding || "hex");
}

export function encrypt (text) {
  const algorithm = "aes-256-ctr";
  let cipher = crypto.createCipheriv(
    algorithm,
      'OMDF5SDG8S4Q3J9T43298QPOIALRRCMB',
      '9040AA1C3901713A',
  );
  let encrypted = cipher.update(text, "utf8", "hex") + cipher.final("hex");
  return encrypted.toString();
}

export function getApiServiceUrl () {
  return window.config.apiFileServiceUrl;
}

export function saveFile(file, roomId, fileId) {
  let checksum = generateChecksum(fileId, "sha256");

  let formData = new FormData();
  formData.append("file", file);
  formData.append("roomId", encrypt(roomId));
  formData.append("fileId", encrypt(fileId));
  formData.append("fileName", encrypt(file.name));
  formData.append("fileSize", encrypt(file.size.toString()));
  formData.append("checksum", checksum);

  return axios.post(window.config.apiFileServiceUrl, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
